import otaClient from '@crowdin/ota-client'
import { use } from 'i18next'
import { currentLang } from '../localization/currentLang'

class CrowdinOtaI18next {
  constructor(hash, language) {
    this.type = 'backend'
    this.otaClient = new otaClient(hash, { languageCode: language })
  }

  read(lang, namespace, callback) {
    this.otaClient
      .getStringsByLocale(lang)
      .then(value => callback(null, value))
      .catch(e => callback(e, null))
  }
}

const parseLang = lang => {
  switch (lang) {
    case 'ge':
      return 'ka'
    case 'kz':
      return 'kk'
    case 'rus':
      return 'ru'
    case 'ua':
      return 'uk'
    default:
      return lang
  }
}

const module = new CrowdinOtaI18next('b859f6633e7da7358a11379disj', parseLang(currentLang))
const i18nextOptions = {
  lng: parseLang(currentLang),
  fallbackLng: false,
}

export let translationsLoaded = false

use(module)
  .init(i18nextOptions)
  .then(() => {
    translationsLoaded = true
  })
